import * as React from 'react';
import { useFeatureToggles } from '@grandvisionhq/state';
import { isModifiedClickEvent } from '@grandvisionhq/utils';
import { updateActiveVariant } from '../../../context/actions.js';
import '../../../context/reducer.js';
import { useProductData } from '../../../context/product-context-hooks.js';
import '../../../context/ProductContext.js';
import '../../../context/CmsContext.js';
import { getFacetPickerConfig } from '../utils/get-facet-picker-config.js';
import { getDeepestTreeLevelForSku } from './utils/get-deepest-tree-level-for-sku.js';

const EcommFacetContext = /*#__PURE__*/ React.createContext({});
const useEcommFacetContext = ()=>React.useContext(EcommFacetContext)
;
const EcommFacetProvider = ({ children  })=>{
    const { dispatch , product: { facetTree , variantFacetTree  } , activeVariant: { sku: sku1  } , facetConfigList ,  } = useProductData();
    const { isOmnivariancyEnabled  } = useFeatureToggles();
    const handleVariantSelection = React.useCallback(({ event , sku , href  })=>{
        // Allow customers to open another variant in a new tab or window, otherwise prevent navigation
        if (!event || !isModifiedClickEvent(event)) {
            event === null || event === void 0 ? void 0 : event.preventDefault();
            dispatch(updateActiveVariant({
                sku
            }));
            window.history.replaceState(null, '', href);
        }
    }, [
        dispatch
    ]);
    const [clickedFacetKeys, setClickedFacetKeys] = React.useState([]);
    const [userHasSelectedASize, setUserHasSelectedASize] = React.useState(false);
    const [notificationType, setNotificationType] = React.useState(undefined);
    const facetPickerConfig = getFacetPickerConfig(facetTree, sku1);
    const deepestTreeLevelForSku = getDeepestTreeLevelForSku(variantFacetTree, sku1);
    const facetLevelConfig = facetConfigList === null || facetConfigList === void 0 ? void 0 : facetConfigList.find((facet)=>{
        var ref;
        return facet.facetKey === (deepestTreeLevelForSku === null || deepestTreeLevelForSku === void 0 ? void 0 : (ref = deepestTreeLevelForSku[0]) === null || ref === void 0 ? void 0 : ref.facetKey);
    });
    const isDeepestNodeRequired = !deepestTreeLevelForSku || deepestTreeLevelForSku.length <= 1 || !(facetLevelConfig === null || facetLevelConfig === void 0 ? void 0 : facetLevelConfig.requiresUserSelection) || clickedFacetKeys.includes(facetLevelConfig.facetKey);
    const isValid = React.useMemo(()=>{
        if (isOmnivariancyEnabled) {
            return isDeepestNodeRequired;
        }
        return !facetPickerConfig.requiresUserSizeSelection || facetPickerConfig.requiresUserSizeSelection && userHasSelectedASize;
    }, [
        isOmnivariancyEnabled,
        facetPickerConfig.requiresUserSizeSelection,
        userHasSelectedASize,
        isDeepestNodeRequired, 
    ]);
    const value = React.useMemo(()=>({
            facetPickerConfig,
            handleVariantSelection,
            isValid,
            notificationType,
            clickedFacetKeys,
            setNotificationType,
            setClickedFacetKeys,
            setUserHasSelectedASize,
            userHasSelectedASize
        })
    , [
        clickedFacetKeys,
        facetPickerConfig,
        handleVariantSelection,
        isValid,
        notificationType,
        userHasSelectedASize, 
    ]);
    return /*#__PURE__*/ React.createElement(EcommFacetContext.Provider, {
        value: value
    }, children);
};

export { EcommFacetContext, EcommFacetProvider, useEcommFacetContext };
//# sourceMappingURL=EcommFacetContext.js.map
